import React from 'react';
import LabeledDropdown from '../LabeledDropdown';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const Variants = props => {
  const {
    variantCount,
    onChange,
    product,
    translate,
    optionValues,
    selectedVariantOptions,
    requiredFieldsBlank,
    optionOrder,
    isVariantAvailable,
    isVariantInStock
  } = props;

  if (!product || !product.product_option_order || !variantCount) {
    return null;
  }

  const { Block } = UX2.Element;
  const { Form } = UX2.Group;

  const listItems = [];
  for (let variantIndex = 0; variantIndex < variantCount; variantIndex++) {
    const optionType = product.option_types[variantIndex];
    const currentOptionIds = optionOrder && optionOrder[optionType.id];
    const fieldId = 'variant_select_' + variantIndex;
    const options = [];
    if (currentOptionIds.length) {
      // For required option dropdowns, we add "-- Select --" as the default option
      options.push(
        <option key={ 'variant_option_select' } value='select'>
          {translate('products.option_select')}
        </option>
      );
    }

    for (const optionId of currentOptionIds) {
      let optionName = optionValues[optionId].name;
      let disabled = false;

      if (isVariantAvailable(variantIndex, optionId)) {
        if (!isVariantInStock(variantIndex, optionId)) {
          if (product.backorderable) {
            optionName = translate('products.backordered_message', { name: optionName });
          } else {
            optionName = translate('products.out_of_stock_message', { name: optionName });
            disabled = true;
          }
        }

        options.push(
          <option key={ 'variant_option_' + optionId } value={ optionId } disabled={ disabled }>
            {optionName}
          </option>
        );
      }
    }

    const selectedOption = selectedVariantOptions[variantIndex].optionValue;
    const selectedValueForDropdown = selectedOption === null ? 'select' : selectedOption;
    const labelColor =
      selectedOption === null && requiredFieldsBlank ? 'error' : 'lowContrast';

    listItems.push(
      <Form.Group key={ fieldId } style={{ marginBottom: 'medium' }}>
        <LabeledDropdown
          labelText={ optionType.presentation }
          labelColor={ labelColor }
          id={ fieldId }
          value={ selectedValueForDropdown }
          onChange={ onChange.bind(null, variantIndex) }
          children={ options }
        />
      </Form.Group>
    );
  }

  return <Block children={ listItems } />;
};

Variants.propTypes = {
  variantCount: PropTypes.number,
  onChange: PropTypes.func,
  product: PropTypes.object,
  translate: PropTypes.func,
  optionValues: PropTypes.object,
  selectedVariantOptions: PropTypes.array,
  requiredFieldsBlank: PropTypes.bool,
  optionOrder: PropTypes.object,
  isVariantAvailable: PropTypes.func,
  isVariantInStock: PropTypes.func
};

export default Variants;
